import type { SessionEvidence } from '@k-ucap/shared';
import type { SessionEvidenceRepository } from './RepositoryInterfaces.js';

const evidence: Map<string, SessionEvidence> = new Map();

export class InMemorySessionEvidenceRepository implements SessionEvidenceRepository {
  async findAll(): Promise<SessionEvidence[]> {
    return Array.from(evidence.values()).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }

  async findById(id: string): Promise<SessionEvidence | undefined> {
    return evidence.get(id);
  }

  async findBySessionId(sessionId: string): Promise<SessionEvidence[]> {
    return Array.from(evidence.values())
      .filter((e) => e.sessionId === sessionId)
      .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }

  async save(item: SessionEvidence): Promise<SessionEvidence> {
    evidence.set(item.id, item);
    return item;
  }

  async delete(id: string): Promise<void> {
    evidence.delete(id);
  }
}

export const createInMemorySessionEvidenceRepository = (): InMemorySessionEvidenceRepository =>
  new InMemorySessionEvidenceRepository();
